"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeCms_de_de = void 0;
function backofficeCms_de_de() {
    return {
        "backoffice.cms.title": "CMS Seiten",
        "backoffice.cms.subtitle": "Erstellen Sie CMS-Seiten welche in Widgets, Applikationen oder externen Systemen angezeigt werden können.",
        "backoffice.cms.pagetitle": "Seiten-Titel",
        "backoffice.cms.editpage": "Seite bearbeiten",
        "backoffice.cms.delete.page": "Seite löschen",
        "backoffice.cms.listempty": "Es wurden noch keine Seiten angelegt...",
        "backoffice.cms.emptytitle": "Keine Seiten gefunden...",
        "backoffice.cms.emptymessage": "Es wurden noch keine Seiten angelegt. Fangen Sie doch einfach an und erstellen Sie Ihre Home-Seite!",
        "backoffice.cms.pages.info": "Infos",
        "backoffice.cms.pages.content": "Inhalt",
        "backoffice.cms.pages.availableinallcountries": "Verfügbar in allen Ländern",
        "backoffice.cms.pages.draft.name": "Name",
        "backoffice.cms.pages.draft.title": "Titel",
        "backoffice.cms.pages.draft.tags": "Tags",
        "backoffice.cms.pages.draft.tagsdescription": "Tags können zum sortieren, filtern oder gruppieren der CMS Seiten verwendet werden",
        "backoffice.cms.pages.draft.transform": "Verwenden",
        "backoffice.cms.pages.draft.transformhint": "Benutze den Titel als Url-konformen Namen",
        "backoffice.cms.pages.draft.metadata.label": "Projektspezifische Daten",
        "backoffice.cms.pages.draft.metadata.description": "Hier können Sie projektspezifische Daten an Ihren CMS Seiten speichern.",
        "backoffice.cms.pages.table.name": "Name",
        "backoffice.cms.pages.table.createdat": "Erstellt am",
        "backoffice.cms.pages.table.title": "Titel",
        "backoffice.cms.pages.table.tags": "Tags",
        "backoffice.cms.pages.projectrelateddata.addkey": "Schlüssel hinzufügen",
        "backoffice.cms.pages.empty.title": "Keine Sprachumgebungen definiert",
        "backoffice.cms.pages.empty.message": "CMS Seiten werden lokalisert angeboten. Damit Sie eine CMS Seite erstellen können, muss mindestens eine Sprachumgebung angelegt werden.",
        "backoffice.cms.pages.empty.createnewlocale": "Neue Sprachumgebungen erstellen",
        "backoffice.cms.tooltip.name": "Zeichenkette welche in der URL angezeigt wird"
    };
}
exports.backofficeCms_de_de = backofficeCms_de_de;
